import { render, staticRenderFns } from "./CompraList.vue?vue&type=template&id=a4d151c4"
import script from "./CompraList.vue?vue&type=script&lang=js"
export * from "./CompraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports